/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import {
  FormPage,
  theme,
  Header,
  Footer,
  Background,
  AlternateTextForReCaptcha,
} from 'shared';

export type TemplateProps = Pick<FormPage, 'header' | 'footer' | 'design'> & {
  displayAlternateTextForReCaptcha?: boolean;
  children: React.ReactNode;
};

const { smallAndUp, lessThanSmall } = theme.BREAKPOINTS;

const Wrapper = styled.div<{ linkColor: string }>`
  a {
    color: ${({ linkColor }) => linkColor};
  }
`;

const ContentWrapper = styled.div`
  padding: 0 12px;
`;

const ReCaptchaMessage = styled(AlternateTextForReCaptcha)`
  margin-top: 24px;
  @media (${lessThanSmall}) {
    padding: 0 29px;
  }
  @media (${smallAndUp}) {
    padding: 0 12px;
  }
`;

const Space = styled.div`
  height: 24px;
`;

export const Template: React.FC<TemplateProps> = (props) => {
  const { header, footer, children, design, displayAlternateTextForReCaptcha } =
    props;
  const { background, linkFontColor, headerAndFooterFont } = design.colors;

  return (
    <Background backgroundColor={background}>
      <Wrapper linkColor={linkFontColor}>
        {header.enabled && (
          <Header header={header} color={headerAndFooterFont} />
        )}
        <Space className="synergy-nform-top-space" />
        <ContentWrapper>{children}</ContentWrapper>
        {(displayAlternateTextForReCaptcha && <ReCaptchaMessage />) || null}
        <Space className="synergy-nform-bottom-space" />
        {footer.enabled && (
          <Footer footer={footer} color={headerAndFooterFont} />
        )}
      </Wrapper>
    </Background>
  );
};
